<template>
  <div class="info-button-create" @click="create">
    お知らせの作成
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    create: async function () {
      const result = await this.$store.dispatch(
        'info/saveInfo',
        'new'
      )

      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.info-button-create {
  @include button-ol-success;
}
</style>
